module.exports = __webpack_public_path__ + "img/19.4.NH3-N.c9bfc491.png";